<template lang="pug">
.v-field-select.field-select(:class="{'field-select--open': open}")
	label.field-select__label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	button.field-select__btn(type="button" @click="open = !open" :id="uniqueId" :disabled="field.disabled")
		span.field-select__btn-placeholder(v-if="!computedValue" key="placeholder") {{field.placeholder}}
		span.field-select__btn-text(v-if="computedValue" key="text") {{computedValue}}
		v-svg-icon.field-select__btn-arrow(icon="chevron-down-sm")
	.field-select__list.scrollbar(@click.stop)
		.field-time
			.field-time__container
				.field-time__list
					.field-time__list-cell
						v-field.field-time__list-field(:field="{type: 'text', size: 'sm', mode: 'time' , placeholder: 'С', mask: { mask: '00'}}" v-model="textFrom" @update:model-value="inputTime")
					.field-time__list-cell
						v-field.field-time__list-field(:field="{type: 'text', size: 'sm', mode: 'time' ,   placeholder: 'По', mask: { mask: '00'}}" v-model="textTo" @update:model-value="inputTime")
				.field-time__checkbox(v-if="field.dayOff")
					v-field-checkbox(:text="field.dayOff.text" v-model="isDayOff" @update:model-value="updateCheckbox")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Array, Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	emits: [
		'update:model-value',
		'update:day-off',
	],

	data() {
		return {
			textFrom: null,
			textTo: null,
			isDayOff: false,
			localValue: null,

			open: false,
			uniqueId: uniqueId('field-select_'),
			hasFocus: false,
			selectValueText: '',
			isSelectValueFound: false,
		};
	},

	computed: {
		activeOption() {
			if (this.field && this.field.options && this.field.options.length) {
				return this.field.options.find(option => option.value === this.localValue);
			}
			return null;
		},

		computedValue() {
			if(this.isDayOff) {

				return this.field?.dayOff?.text

			} else if(!this.isDayOff && this.textFrom && this.textTo) {

				return `${this.textFrom} - ${this.textTo}`
			}
			return null;

		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		if (this.field.searchable && this.localValue) {
			this.selectValueText = this.activeOption ? this.activeOption.text || this.activeOption.value : '';
		}
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		inputTime() {
			this.localValue = [ this.textFrom, this.textTo] ;
			this.handleInput();
		},

		updateCheckbox() {
			this.$emit('update:day-off', this.isDayOff)
		},

		handleClickSearchable(e, option) {
			this.localValue = option.value;
			this.handleInput();
			this.open = false;
			this.selectValueText = option.text;
		},

		cleanField() {
			if (this.foundSelectValue() !== this.selectValueText) {
				this.selectValueText = '';
				this.localValue = '';
			}
		},

		toggleOpen() {
			if (this.field.disabled) {
				return false;
			}
			this.open = !this.open;
			this.selectValueText = '';
		},


		inputFocus() {
			this.hasFocus = true;
		},

		inputBlur() {
			this.hasFocus = false;
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
			if(this.field.dayOff) {
				this.isDayOff = this.field.dayOff.value;
			}
			if(this.localValue && this.localValue.length) {
				const [
					first = null,
					second = null
				] = this.localValue;
				this.textFrom = first;
				this.textTo = second;
			} else {
				this.textFrom = '';
				this.textTo = '';
			}

		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		}
	}
};
</script>
